export class OptionCost {
  public customerPrice = 0.0;
  public dealerPrice = 0.0;
}
